<template>
  <div>
    <el-upload ref="elUpload"
               :action="actionUrl"
               
               :on-remove="handleRemove"
               :name="name"
               :headers="headers"
               accept=".xls,.xlsx"
               :before-upload="beforeUpload"
               :limit="limit"
               :on-exceed="onExceed"
               :file-list="fileList"
               :on-success="onSuccess"
               :data="otherData">
      <el-button slot="trigger"
                 size="small"
                 type="primary">上传</el-button>
    </el-upload>
    <div slot="tip"
         class="el-upload__tip">{{ tip }}</div>
    <el-dialog :visible.sync="dialogVisible"
               :append-to-body="true"
               style="text-align: center">
      <video height="500px"
             width="100%"
             controls
             :src="dialogImageUrl"></video>
    </el-dialog>
  </div>
</template>
<script>
import store from "../../store";

export default {
  name: "ImageUpload",
  data () {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      name: "imgFile",
      listType: "picture-card",
      actionUrl: process.env.VUE_APP_BASE_API + "/common/uploadFile",
      headers: {
        Authorization: "",
      },
      otherData: {},
      accept: this.acceptType,
      limit: this.maxNumber,
      fileList: [],
    };
  },
  props: {
    imageList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tipInfo: {
      type: String,
      default: function () {
        return "";
      },
    },
    maxNumber: {
      type: Number,
      default: function () {
        return 1;
      },
    },
    acceptType: {
      type: String,
      default: function () {
        return "xlsx";
      },
    },
  },
  computed: {
    tip: function () {
      return this.tipInfo === ""
        ? '请上传Excel'
        : this.tipInfo;
    },
  },
  watch: {
    imageList: function () {
      if (this.imageList.length != 0) {
        this.fileList = this.imageList;
        this.$emit('updateImg', this.fileList);
      } else {
        this.fileList = [];
        this.$emit('updateImg', this.fileList);
      }
    },
  },
  created () {
    if (this.imageList.length != 0) {
      this.fileList = this.imageList;
    } else {
      this.fileList = [];
    }
  },
  methods: {
    clearFileList () {
      this.$refs["elUpload"].clearFiles();
      this.fileList = [];
    },
    handleRemove (file, fileList) {
      this.fileList.forEach((ele, idx) => {
        if (ele.name == file.name) {
          this.fileList.splice(idx, 1);
        }
      });
      this.$emit('updateImg', fileListTemp);
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload (file) {
      this.headers.Authorization = store.getters.token;
      this.otherData.language = store.getters.language;
    },
    onExceed (files, fileList) {
      this.$message.warning("最多可以上传" + this.limit + "个文件");
    },
    onSuccess (response, file, fileList) {
      if (response.code === 200) {
        this.fileList.push({
          name: response.result.filename,
          filetype: response.result.filetype,
          path: response.result.url,
          url: this.$publicData.imgUrl + response.result.url,
        });
        this.$emit('updateImg', this.fileList);
      } else {
        this.$message.error(response.message);
        fileList.splice(
          fileList.findIndex((item) => item.uid === file.uid),
          1
        );
        if (
          response.code === 50008 ||
          response.code === 50012 ||
          response.code === 50014
        ) {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        }
      }
    },
  },
};
</script>
<style scoped>
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
</style>